import { getStyles } from './CalendarYear.styles';
import { styled } from '../../../Utilities';
import { CalendarYearBase } from './CalendarYear.base';
export var CalendarYear = styled(CalendarYearBase, getStyles, undefined, {
  scope: 'CalendarYear'
});